module.exports = __webpack_public_path__ + "img/76.0c076ccb.webp";